import { NetworkError } from '@kit/sync/http/network-error';
import { t } from '@/shared/i18n/t';

export function describeLoadError(error: unknown): string {
  return error instanceof NetworkError
    ? t('Offline: access and sessions can only be managed with a connection.')
    : t('They could not be loaded. Try again.');
}
